import { useCallback, useEffect } from 'react'
import Loader from './Loader'
import { logout } from '../helpers/account'
import { isCustomerUnAuthorized } from '../helpers/utils'

function LogoutExpiredUser({
    error,
    redirectURL = null,
    customer,
    messageSuffix,
}) {
    const shouldLogout = error || isCustomerUnAuthorized(customer)

    const handleError = useCallback(() => {
        if (!error && !customer) return null
        if (shouldLogout) {
            setTimeout(async () => {
                await logout(true, redirectURL)
            }, 2000)
        }
    }, [error, redirectURL])

    useEffect(() => {
        handleError()
    }, [error, handleError])

    if (!error && !customer) return null

    if (shouldLogout) {
        return (
            <Loader
                text={`Seems like your session has expired, ${
                    messageSuffix || 'redirecting you to login...'
                }`}
            />
        )
    }

    return null
}

export default LogoutExpiredUser
